export const formatDate = (dateString) => {
  const date = new Date(dateString);

  // Get day, month, year, hours, and minutes
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" }); // "Feb"
  const year = date.getFullYear(); // 2025
  const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2-digit minutes
  const amPm = date.getHours() >= 12 ? "PM" : "AM";

  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th"; 
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getOrdinal(
    day
  )} ${month} ${year} ${hours}:${minutes} ${amPm}`;
};
